var _rect, _path, _path2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.0000190735,
    width: 300,
    height: 300,
    rx: 23.4375,
    fill: "#6CB3DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 276.562V23.4375C0 10.4933 10.4933 -1.90735e-05 23.4375 -1.90735e-05H257.683L35.5164 300H23.4375C10.4933 300 0 289.507 0 276.562Z",
    fill: "url(#paint0_linear_126_340)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300 276.562V23.4375C300 10.4933 289.507 -4.57764e-05 276.562 -4.57764e-05H62.1951L247.103 300H276.562C289.507 300 300 289.507 300 276.562Z",
    fill: "url(#paint1_linear_126_340)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_126_340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3139 215.617C79.5332 219.481 86.4673 223.739 90.3357 225.738L134.003 166.681L110.954 132.654L75.6474 182.707C72.5576 187.128 70.7104 191.389 70.1059 195.491C69.7361 199.551 70.1186 203.417 71.2536 207.089C72.6233 210.719 73.8539 212.663 76.3139 215.617Z",
    fill: "url(#paint2_linear_126_340)",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_126_340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.808 85.2703C125.022 75.7299 136.652 71.465 143.704 72.5931C150.888 73.6402 157.123 78.4788 162.409 87.1087L241.279 216.036C235.295 220.625 226.362 224.039 222.803 225.052C219.376 225.984 215.843 226.3 212.206 225.999C208.614 225.475 205.115 224.214 201.71 222.214C198.349 219.992 195.283 216.617 192.509 212.09L114.808 85.2703Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_126_340",
    x: 69.7851,
    y: 132.483,
    width: 64.4301,
    height: 93.4816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0138221,
    dy: 0.0276442
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0992237
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_340",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_126_340",
    x: 114.624,
    y: 72.2452,
    width: 126.868,
    height: 154.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0138221,
    dy: 0.0276442
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0992237
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_340",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_340",
    x1: 81.9899,
    y1: -56.2972,
    x2: 38.9169,
    y2: 236.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.471665,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944985,
    stopColor: "#8EE2F4",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_126_340",
    x1: 284.131,
    y1: 196.096,
    x2: 3.40048,
    y2: 20.4029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122198,
    stopColor: "#A0E2FB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772943,
    stopColor: "#AAE3F5",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_126_340",
    x1: 126.809,
    y1: 148.456,
    x2: 77.0415,
    y2: 219.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fea23b3896224b2b56ca4c43cc87fedb.svg";
export { ForwardRef as ReactComponent };